import React, { useState, useEffect } from "react";
import { Flex, Box, Button } from "rebass";
import { Input } from "@rebass/forms";
import Select, { components } from "react-select";
import ChevronDown from "../../icons/ChevronDown";
import { getLocalizedString } from "../../utils";

import Search from "../../icons/Search";
import { useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useResponsive from "../../hooks/useResponsive";

function AgentsFilter({ filterAgents }) {
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("all");
  const searchBox = useRef();

  const { isMobile, isTabletSm } = useResponsive();

  useEffect(() => {
    filterAgents(query.toString().toLowerCase(), status);
  }, [query, status]);

  const statusSelectStyle = {
    input: (styles) => ({
      ...styles,
    }),
    control: (styles) => ({
      ...styles,
      border: 0,
      borderRadius: 0,
      backgroundColor: "white",
      fontSize: 12,
      marginTop: 0,
      boxShadow: "none",
    }),
    menu: (styles) => ({
      ...styles,
      border: "1px solid rgba(0,0,0,.2)",
      padding: 0,
      borderRadius: 0,
      fontSize: 12,
      marginTop: 0,
      marginBottom: 0,
      boxShadow: "none",
    }),
    option: (styles) => ({
      ...styles,
      marginTop: 1,
      marginBottom: 1,
    }),
  };
  const agentStatusList = [
    { value: "all", label: getLocalizedString("Tutti").toUpperCase() },
    { value: "APPROVED", label: getLocalizedString("Approvato").toUpperCase() },
    {
      value: "Non Approvato",
      label: getLocalizedString("Non Approvato").toUpperCase(),
    },
  ];

  function changeQuery(e) {
    if (e.keyCode === 13) {
      filterAgents(query.toString().toLowerCase(), status);
    }
  }

  function changeQueryClick() {
    filterAgents(query.toString().toLowerCase(), status);
  }

  function clearQuery() {
    setQuery("");
    searchBox.current.value = "";
  }

  return (
    <Flex
      width={1}
      style={{
        backgroundColor: "#f5f5f5",
      }}
      justifyContent="flex-start"
      flexDirection={["column", "column", "row"]}
      key="client-filter"
    >
      <Box
        width={[1, 1, 1 / 2]}
        m={0}
        p={3}
        style={{
          position: "relative",
        }}
      >
        <Input
          ref={searchBox}
          id="client"
          name="client"
          type="text"
          placeholder={getLocalizedString("Search filter")}
          style={{
            backgroundColor: "#fff",
            border: "none",
            fontSize: 12,
            paddingTop: 11,
            paddingBottom: 11,
          }}
          onChange={(e) => setQuery(e.target.value)}
          onKeyUp={changeQuery}
        />
        <Box
          sx={{
            position: "absolute",
            top: ["38px"],
            right: ["20px"],
            transform: "translateY(-50%)",
            cursor: "pointer",
          }}
          onClick={changeQueryClick}
        >
          {isMobile || isTabletSm ? (
            query ? (
              <Box
                sx={{
                  marginTop: "-10px",
                  marginRight: "10px",
                }}
                onClick={clearQuery}
              >
                <AiOutlineClose size="18px" />
              </Box>
            ) : (
              <Search
                sx={{
                  color: "#fff",
                  width: "18px",
                  margin: 0,
                  cursor: "pointer",
                  fill: "black",
                }}
              />
            )
          ) : (
            <Search
              sx={{
                color: "#fff",
                width: "18px",
                margin: 0,
                cursor: "pointer",
                fill: "black",
              }}
            />
          )}
        </Box>
      </Box>
      {/* <Box width={[1, 1, 1/4]} m={0} p={3} style={{display:'none'}}>
        <Select 
          styles={statusSelectStyle}
          placeholder={getLocalizedString("Select agent status").toUpperCase()}
          name='status'
          id="agentStatus"
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator : (props) => 
              <components.DropdownIndicator {...props}>
                <ChevronDown style={{ width:24, height:24, color: '#3e3e3e'}} />
              </components.DropdownIndicator>
              
          }}
          onChange={(e) => setStatus(e.value)}
          options={agentStatusList}
          isSearchable={false}
        />
      </Box> */}
      {!isMobile && !isTabletSm && (
        <Flex width={[1, 1, "auto"]} m={0} p={3} justifyContent={"flex-end"}>
          <Button
            variant="primary"
            sx={{
              fontFamily: "Open Sans",
              fontSize: "0.8em",
              fontWeigth: 800,
              backgroundColor: "#545454",
              color: "white",
              textTransform: "uppercase",
              visibility: searchBox?.current?.value ? "visible" : "hidden",
              "&:hover": {
                backgroundColor: "#909090",
                color: "white",
              },
            }}
            onClick={clearQuery}
          >
            {getLocalizedString("CLEAR_FILTERS")}
          </Button>
        </Flex>
      )}
    </Flex>
  );
}

export { AgentsFilter };
